import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import TenantUserEditForm from '@src/features/tenant/tenant-user/TenantUserEditForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CompanyUserEdit() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <TenantUserEditForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CompanyUserEdit;
